<template>
	<section class="hero">
		<h1 data-aos="fade-up" class="hero__title">{{ $t('modules.loyalty_program_module.loyalty_program_hero.loyalty_program') }}</h1>
		<GlobalImage class="hero__image hero__image--silver" src="loyalty-hero-silver.png" :width="948" alt="Loyalty hero silver" />
		<GlobalImage class="hero__image hero__image--gold" src="loyalty-hero-gold.png" :width="1048" alt="Loyalty hero gold" />
		<GlobalImage
			class="hero__image hero__image--platinium"
			:src="getLocaleLang() === 'pl' ? 'loyalty-hero-platinium-v2.png' : 'loyalty-hero-platinium-en.png'"
			:alt="getLocaleLang() === 'pl' ? 'Loyalty hero platinium' : 'Loyalty hero platinium en'"
			:width="1118" />
		<GlobalImage class="hero__image hero__image--mobile" src="loyalty-hero-mobile.png" :width="1077" alt="Loyalty hero mobile" />
		<GlobalImage class="hero__circle hero__circle--gold" src="loyalty-hero-gold-circle.png" :width="527" alt="Loyalty hero gold circle" />
		<GlobalImage class="hero__circle hero__circle--silver" src="loyalty-hero-silver-circle.png" :width="507" alt="Loyalty hero silver circle" />
		<GlobalImage
			class="hero__circle hero__circle--platinium"
			src="loyalty-hero-platinium-circle.png"
			:width="1024"
			alt="Loyalty hero platinium circle" />
	</section>
</template>

<script setup lang="ts">
const { getLocaleLang } = usei18nService()
</script>

<style scoped lang="scss">
@import './LoyaltyProgramHero.scss';
</style>
